import * as React from 'react';
import { Dropdown, MenuItem, Tooltip, OverlayTrigger } from 'react-bootstrap';
import { routeUrl } from '../../LinkUrl';
import { useRouter } from '../../hooks/router/useRouter';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/reducers';

export interface ProfileDropDownProps {
    additionaClass?: string;
    disableProfile?: boolean;
}
const tooltip = (
    <Tooltip id="tooltip-left">
        Fill up the KYC form
    </Tooltip>
)
const userProfileMenu = (user:any) => {
    return (
        <div>
            <div className="left-body">
                <div className="profile-img">
                    {user.rawImage && user.rawImage !== '' && <img src={user.rawImage} />}
                </div>
            </div>
            <div className="right-body">
                <h5 className="text name">{user.fullName}
                </h5>
                <h5 className="text email">{user.email}
                </h5>
            </div>
        </div>
    )
}
const ProfileDropDown: React.SFC<ProfileDropDownProps> = (props: ProfileDropDownProps) => {
    const user = useSelector((state: RootState) => state.profile)
    const { history } = useRouter();
    return (
        <div className="right-nav">
            <ul className={`right-nav-list ${props.additionaClass}`}>
                <li>
                    <Dropdown id="admin-profile" className="dropdown-nav" pullRight>
                        <Dropdown.Toggle noCaret>
                            <div className="admin-img">
                                {user.rawImage && user.rawImage !== '' && <img src={user.rawImage} />}
                            </div>
                        </Dropdown.Toggle>
                        <Dropdown.Menu className="dropdown-list">
                            <MenuItem
                                eventKey="1"
                                disabled={props.disableProfile}
                                className="admin-profile"
                                onClick={(event: any) => {
                                    event.preventDefault();
                                    if (!props.disableProfile) {
                                        history.push(routeUrl.student.profile);
                                    }
                                }}
                            >
                                {
                                    props.disableProfile ? 
                                    <OverlayTrigger overlay={tooltip} placement="left">
                                        {userProfileMenu(user)}
                                    </OverlayTrigger> : 
                                    userProfileMenu(user)
                                }
                            </MenuItem>
                            <MenuItem
                                eventKey="2"
                                className="admin-logout"
                                onClick={(event: any) => {
                                    event.preventDefault();
                                    history.push('/logout');
                                }}
                            >
                                <i className="fuse-icon fuse-icon-logout" />
                                Logout
                            </MenuItem>
                        </Dropdown.Menu>
                    </Dropdown>
                </li>
            </ul >
        </div >
    )
}


export default ProfileDropDown;